import { Area, AreaChart, ResponsiveContainer, Tooltip } from 'recharts';
import React from 'react';
import { analyticsChartTheme } from 'util/chartUtils';
import CustomTooltip from '../../common/CustomToolTIp';

const PreparedChart = ({ data }) => (
  <ResponsiveContainer className="rounded-bottom-right overflow-hidden" width="100%" height={88}>
    <AreaChart
      data={data || []}
      margin={{
        top: 8, right: 2, left: 2, bottom: 0,
      }}
    >
      <defs>
        <linearGradient id="total-ctr-fill" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={analyticsChartTheme.clickRateFill} stopOpacity={1} />
          <stop offset="100%" stopColor={analyticsChartTheme.clickRateFill} stopOpacity={0.12} />
        </linearGradient>
      </defs>
      <Area
        type="monotone"
        dataKey="ctr"
        strokeWidth={2.5}
        stroke={analyticsChartTheme.clickRate}
        fill="url(#total-ctr-fill)"
        fillOpacity={1}
        dot={false}
        isAnimationActive={false}
      />
      <Tooltip
        content={<CustomTooltip dataKey="ctr" />}
      />
    </AreaChart>
  </ResponsiveContainer>
);

export default PreparedChart;
